define('shoptheme/components/product/options',[
	"require",
	"jquery",
	"lodash",
	"cartware/components/Registry",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"cartware/dom/event/trigger",
	"select2",
	"text!./options/templates/color.html",
	"text!./options/templates/badge.html"
], function(
	require,
	$,
	_,
	Registry,
	Component,
	BEM,
	triggerEvent,
	S2,
	ColorOptionTemplate,
	BadgeOptionTemplate
) {
	var templates = {
		color: _.template(ColorOptionTemplate),
		badge: _.template(BadgeOptionTemplate)
	};

	return Component.create({
		block:			null,
		options:		null,

		$init: function() {
			this.block = BEM.block("product-options");

			this.options = this.block.getElements("attribute-option");

			Registry().retrieve("product.view.configurable.spConfig", _.bind(this.initializeRendering, this));
			
			this.initEngravingOption();
		},

		initializeRendering: function() {
			var self = this;
			this.options.each(function() { self.initializeOptionElement(this); });
		},

		initializeOptionElement: function(element) {
			var element = $(element),
				select = element.find("select"),
				value = select.val() << 0,
				attributeCode = element.data("attribute-code"),
				attributeData = _.find(spConfig.config.attributes, function(attribute, attributeId) {
					return attribute.code == attributeCode;
				}),
				attributeExtension = _.find(spConfig.config.attribute_extensions, function(attribute, attributeId) {
					return attribute.code == attributeCode;
				}),
				renderer = _.get(attributeExtension, "renderer", "default"),
				template = _.get(templates, renderer),
				displayNode = $('<div class="display" />').prependTo(element),
				options = [];

			var setActiveValue = function(value) {
				displayNode
					.findBlock("super-attribute-select")
					.getElements("list-item")
					.bemRemoveModifier("active")
					.filter('[data-option="' + value + '"]')
					.bemAddModifier("active");
			};

			if (!template) {
				select.on("attribute/fillSelect", function() {
					triggerEvent(this, "change");
				});

				select.on("change", function(e) {
					if ("undefined" === typeof e.originalEvent) {
						triggerEvent(this, "change");
					}
				});

				$.fn.select2.amd.require(
					["select2/utils", "select2/dropdown", "select2/dropdown/attachContainer", "select2/dropdown/closeOnSelect"],
					function (Utils, Dropdown, AttachContainer, CloseOnSelect) {
						select.select2({
							dropdownAdapter: Utils.Decorate(Utils.Decorate(Dropdown, AttachContainer), CloseOnSelect),
							width: "100%"
						});
					}
				);
			} else {
				element.on("click", "[data-option]", function() {
					var value = $(this).data("option");

					// todo: this seems to be called twice for no obvious reason

					//if ($(this).is(":modifier(disabled)")) return;

					select.val(value);
					triggerEvent(select, "change")
				});

				select.on("change", function() {
					var value = select.val();

					if (!value) return;

					setActiveValue(value);
				});

				function render() {
					select.find("option").each(function() {
						var node = $(this),
							select = node.parent(),
							attributeId = select.prop('id').replace(/[a-z]*/, ''),
							value = node.prop('value'),
							option = {
								value: value,
								label: node.html(),
								tmpl: node.data('tmpl')
							};

						if (!value) return;

						var configOptions = spConfig.config.attributes[attributeId].options;

						for (var i = 0, j = configOptions.length; i < j; i++) {
							if (configOptions[i].id == option.value) {
								if (configOptions[i].allowedProducts.length == 1
									&& _.get(spConfig, '_configurable.simples')
								) {
									for (var k in spConfig._configurable.simples) {
										if (k == configOptions[i].allowedProducts[0]) {
											option.qty = spConfig._configurable.simples[k].qty;
											break;
										}
									}
								}
								break;
							}
						}

						_.forEach(spConfig.dataProviders, function(provider) {
							if ("function" == typeof provider.provideSelectOption) {
								provider.provideSelectOption(option, select, attributeData.id);
							}
						});

						options.push(option);
					});

					function done() {
						element.bemAddModifier("rendered");
						displayNode
							.empty()
							.html(template({
								options: options,
								attribute: attributeData,
								attributeExtension: attributeExtension
							}));
					}

					if (spConfig.dataProviders.length) {
						+function() {
							var i = 0, j = spConfig.dataProviders.length;

							function next(result) {
								var provider;

								options = result;

								if (i >= j) {
									done();
									return;
								}

								provider = spConfig.dataProviders[i];
								i++;

								if ("function" == typeof provider.sortSelectOptions) {
									options = provider.sortSelectOptions(options, attributeId);

									if ("object" === typeof options && "then" in options) { // promise
										options.then(next);
									} else {
										next(options);
									}

									return;
								}

								next(options);
							}

							next(options);
						}();
					} else {
						done();
					}
				}

				render();
				select.on("attribute/fillSelect", function() {
					options = [];
					render();
				});
			}

			if (value) {
				setActiveValue(value);
			}
		},

		initEngravingOption: function() {
			var block = $('[data-engraving-block]');

			if (block.length) {
				var showLink = block.find('[data-show-engraving-field]'),
					priceNotice = block.parents('dl').find('.price-notice'),
					inputBox = block.find('.input-box'),
					input = inputBox.find('input[type="text"]'),
					maxCharactersBlock = block.find('[data-max-characters]'),
					previewBlock = block.find('[data-engraving-preview]'),
					saveEngravingButton = block.find('[data-save-engraving]'),
					engravingNoticeBlock = block.find('[data-engraving-notice]'),
					savedEngravingBlock = block.find('[data-saved-engraving]'),
					maxCharacters = maxCharactersBlock.data('max-characters'),
					closeButton = $('<a href="#">&times;</a>').hide();


				closeButton.on('click', function (e) {
					e.preventDefault();
					closeButton.hide();
					inputBox.hide();
					showLink.show();
					savedEngravingBlock.hide();
					savedEngravingBlock.html('');
					previewBlock.html('');
					input.val('');
					maxCharactersBlock.html(maxCharacters);
				});

				input.on('change keyup', function(e){
					var elem = $(this);
					previewBlock.html(elem.val());
					savedEngravingBlock.html(elem.val());
					maxCharactersBlock.html(parseInt(maxCharacters, 10) - elem.val().length)
				});

				priceNotice.append(closeButton);

				showLink.on('click', function(e){
					e.preventDefault();
					closeButton.show();
					inputBox.show();
					showLink.hide();
				});

				saveEngravingButton.on('click', function(e) {
					e.preventDefault();
					if (input.val().length) {
						inputBox.hide();
						closeButton.hide();
						savedEngravingBlock.show();
					}
				});

				savedEngravingBlock.on('click', function(e){
					e.preventDefault();
					inputBox.show();
					closeButton.show();
					savedEngravingBlock.hide();
				});
			}
		}
			
	});
});
